import { PurchaseJourney } from 'utils/constants';
import { NewPlanStages } from './constants';

export const isManualFlowEnabled = (
    purchaseJourney: PurchaseJourney | string,
    showManualFlow: boolean
) => {
    const showManualFlowInV1 =
        purchaseJourney === PurchaseJourney.V1 && showManualFlow;
    return purchaseJourney === PurchaseJourney.V0 || showManualFlowInV1;
};

export const getPlanStageBackFromReviewDetails = (
    permissions: any,
    planDetails: any
) => {
    const showManualFlow = isManualFlowEnabled(
        permissions?.purchase_journey,
        planDetails?.showManualFlow
    );
    const planStageBackFromReviewDetails = showManualFlow
        ? NewPlanStages.USER_DETAILS
        : NewPlanStages.PLAN;
    return planStageBackFromReviewDetails;
};
